"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHtmlToWord = useHtmlToWord;
// useHtmlToWord.ts
const react_1 = require("react");
const apiFetch_1 = require("../utils/apiFetch");
function useHtmlToWord() {
    const handleDownload = (0, react_1.useCallback)((html_1, ...args_1) => __awaiter(this, [html_1, ...args_1], void 0, function* (html, fileName = "export.docx") {
        try {
            const response = yield (0, apiFetch_1.apiFetch)(`${process.env.REACT_APP_TEMPLATE_BUILDER_URL}/export/docx`, {
                method: "POST",
                body: JSON.stringify({ html, fileName }),
            });
            if (!response.ok) {
                throw new Error("Failed to generate DOCX");
            }
            const blob = yield response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error("Word download failed:", error);
            alert("Failed to download Word document. Please try again.");
        }
    }), []);
    return { handleDownload };
}
